import classNames from 'classnames';
import get from 'lodash/get';
import moment from 'moment';
/* HOOKS */
import useTabName from 'src/hooks/useTabName';
/* COMPONENT LIB */
import { ButtonMenu, Checkbox, Flex, MDIIcon } from '@solinkcorp/solink-components';
/* MISC */
import DotsVertical from '@mdi/svg/svg/dots-vertical.svg?react';
import useLocale from 'src/hooks/useLocale';
import { NOTIFICATIONS_FILTER_BY_STATE, TAB_VIDEO } from 'vd-constants';

const NotificaitonItem = (props) => {
  const {
    className,
    darkTheme,
    data,
    disableArchive,
    disableMarkAsRead,
    id,
    index,
    isChecked,
    isNew,
    isRead,
    onCheck,
    onArchive,
    onMarkAsRead,
    onView,
  } = props;

  const locale = useLocale();
  const { localeCode } = locale;
  const tabName = useTabName();

  const handleOnArchive = () => onArchive(index);
  const handleOnMarkAsRead = () => onMarkAsRead(index);
  const handleViewClick = () => {
    const isVideoPage = tabName === TAB_VIDEO;
    onView(index, isVideoPage);
  };

  const { created, body, report: { name } = {}, state, title } = data;

  const reportName = get(name, localeCode, get(name, 'en-CA'));
  const colorMode = darkTheme ? 'dark' : 'light';

  const rootClass = classNames('notification-card', className, {
    dark: darkTheme,
    new: isNew,
    unread: !isRead && state === NOTIFICATIONS_FILTER_BY_STATE.unread,
  });

  return (
    <Flex alignItems="center" className={rootClass} data-index={index} justifyContent="flex-start">
      {!disableArchive && (
        <Checkbox
          changeParams={{ index }}
          checked={isChecked}
          className="card-checkbox"
          colorMode={colorMode}
          onChange={onCheck}
          name={`notification-${id}`}
        />
      )}
      <Flex
        alignItems="flex-start"
        className="card-content-wrap"
        flexDirection="column"
        justifyContent="flex-start"
        onClick={handleViewClick}
      >
        <div className="subtitle-row">
          <div className="notification-title">{title}</div>
          <div className="subtitle-time">{moment(created).format('MMM D, YYYY HH:mm:ss')}</div>
        </div>
        <div className="notification-body">{body}</div>
        {reportName && (
          <div className="notification-body">
            {locale.notifications.generatedBy}: {reportName}
          </div>
        )}
      </Flex>
      <ButtonMenu
        buttonColorMode={colorMode}
        buttonIcon={<MDIIcon icon={DotsVertical} size={18} />}
        buttonIconOnly
        buttonType="clear"
        className="action-button menu-button"
        colorMode={colorMode}
        id={`notification-${id}-menu`}
        menuItems={[
          {
            onClick: handleViewClick,
            text: locale.notifications.view,
            type: 'action',
          },
          {
            isVisible: !disableMarkAsRead,
            onClick: handleOnMarkAsRead,
            text: locale.notifications.markAsRead,
            type: 'action',
          },
          {
            isVisible: !disableArchive,
            onClick: handleOnArchive,
            text: locale.notifications.archive,
            type: 'action',
          },
        ]}
      />
    </Flex>
  );
};

export default NotificaitonItem;
